import { getDisabledRoles } from "@utils/workspace-role-utils";
import { RoleAutocomplete } from "@components/role/role-autocomplete/role-autocomplete";
import { RoleAutocompleteProps } from "@components/role/select-role-utils";
import { FaroCoreApiConst, FaroCoreApiTypes } from "@stellar/core-api-client";

/** Renders a dropdown to select company role */
export function CompanyRoleAutoComplete<
  T extends FaroCoreApiTypes.CompanyRole
>({
  selectedRole,
  onChange,
  onResetSelection,
  isRequired = false,
  placeholder = "Select a role...",
  shouldAllowAllRolesSelection = false,
}: RoleAutocompleteProps<T>): JSX.Element {
  const disabledRoles: FaroCoreApiTypes.CompanyRole[] =
    shouldAllowAllRolesSelection || !selectedRole
      ? []
      : getDisabledRoles(selectedRole);

  return (
    <RoleAutocomplete
      labelTitle="Workspace role"
      isRequired={isRequired}
      selectedRole={selectedRole}
      onChange={onChange}
      onResetSelection={onResetSelection}
      placeholder={placeholder}
      roles={FaroCoreApiConst.allCompanyRoles as T[]}
      disabledRoles={disabledRoles as T[]}
      link="workspaceRolesHelp"
      dataTestId="workspace-role-selector"
    />
  );
}
